import React from 'react';
import PropTypes from 'prop-types';

import './VerticalList.css';

const TrendingItem = ({ item, isLast }) => {
  const title = item.category ? (
    <span>{item.title}</span>
  ) : (
    <span>{item.category}</span>
  );

  return (
    <li className="tvt-vertical-list_item--no-border">
      <h3 className="tvt-trending-item__title">{title}</h3>
      <p className="tvt-trending-item__body">{item.body}</p>
    </li>
  );
};

TrendingItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    date: PropTypes.string,
    body: PropTypes.string
  }).isRequired,
  isLast: PropTypes.bool
};

TrendingItem.defaultProps = {
  isLast: false
};

const VerticalList = ({ addlClasses, hideTitle, title, list }) => {
  const displayItems = items =>
    items && items.length > 0
      ? items.map(item => {
          const titleText = item.title ? <span>{item.title}</span> : '';
          const t = item.html ? (
            <span dangerouslySetInnerHTML={item.html} />
          ) : (
            titleText
          );
          return (
            <ul>
              <li>
                <span>
                  {t}
                  {item.description}
                </span>
                {displayItems(item.items)}
              </li>
            </ul>
          );
        })
      : null;

  return (
    <div className={`tvt-vertical-list ${addlClasses}`}>
      {!hideTitle && (
        <div className="tvt-vertical-list__header">
          <h3 className="tvt-vertical-list__title">{title}</h3>
        </div>
      )}
      <div className="tvt-vertical-list_items">
        {list.map(release => (
          <div className="tvt-vertical-list_section-release-wrapper">
            <div className="tvt-vertical-list_section-title">
              {`CVMi ${release.version}`}
            </div>
            <div className="tvt-vertical-list_section-date">{release.date}</div>
            {release.categories.map(category => {
              const titleText = category.title ? (
                <span>{category.title}</span>
              ) : (
                ''
              );
              const t = category.html ? (
                <span dangerouslySetInnerHTML={category.html} />
              ) : (
                titleText
              );
              return (
                <>
                  <div className="tvt-vertical-list_section-category">{t}</div>
                  {displayItems(category.items)}
                </>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

VerticalList.propTypes = {
  title: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      date: PropTypes.string,
      body: PropTypes.string
    })
  ).isRequired,
  addlClasses: PropTypes.string,
  hideTitle: PropTypes.bool
};

VerticalList.defaultProps = {
  title: 'TV Time Insights',
  addlClasses: '',
  hideTitle: false
};
export default VerticalList;
